import { render, staticRenderFns } from "./Daizhifu.vue?vue&type=template&id=87403db0&scoped=true"
import script from "./Daizhifu.vue?vue&type=script&lang=js"
export * from "./Daizhifu.vue?vue&type=script&lang=js"
import style0 from "./Daizhifu.vue?vue&type=style&index=0&id=87403db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87403db0",
  null
  
)

export default component.exports